import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
export default function useRevokeApiKey() {
  const client = useQueryClient()
  const {enqueueSnackbar} = useSnackbar()
  const mutation = useMutation({
    mutationFn: async (id: number) => {
      return await api.auth.revokeApiKey(id)
    },
    onSuccess: async () => {
      enqueueSnackbar('Chave revogada com sucesso', {variant: 'success'})
      await client.invalidateQueries({queryKey: ['list-api-keys']})
    },
    onError: () => enqueueSnackbar('Não foi possível revogar a chave no momento', {variant: 'error'}),
  })
  return mutation
}
